import * as t from './actionTypes';
import * as constants from './constants';
import { isEmpty } from 'lodash';
import axios from 'axios';
//import labelsnl from '../../default-labels.json';

const initialState = {
    appsettings: {
        lang: 1043,
        detailwidth: 50
    },
    shellSettings: {
        collapsed: true,
    },
    personsgridCollumns: ['Firstname','DisplayName','Company','Department','JobDescription','Employer' ],
    personsgridGroups: []
}

function loadFromLocalStorage(key, defaultvalue) {
    let storageObj = localStorage.getItem(key);
    try {
        storageObj = (storageObj && JSON.parse(storageObj))
    } catch (e) {
        storageObj = defaultvalue; //set back to default...
    }
    if (isEmpty(storageObj)) {
        storageObj = defaultvalue;
    }
    return storageObj;
}

export function loadUserSettings() {
    return function (dispatch) {
        //shellsettings
        let shellobj = loadFromLocalStorage(constants.SHELLSETTINGS, initialState.shellSettings);
        dispatch({
            type: t.LOAD_SHELLSETTINGS,
            payload: shellobj
        });

        //appsettings
        let appobj = loadFromLocalStorage(constants.APPSETTINGS, initialState.appsettings);
        dispatch({
            type: t.SAVE_APPSETTINGS,
            payload: appobj
        });
        loadLabels(appobj.lang);
    }
}
export function saveAppSettings(appSettings) {
    localStorage.setItem(constants.APPSETTINGS, JSON.stringify(appSettings));
    loadLabels();
    return {
        type: t.SAVE_APPSETTINGS,
        payload: appSettings
    }
}
export function saveShellSettings(currentSettings) {
    localStorage.setItem(constants.SHELLSETTINGS, JSON.stringify(currentSettings));
    return {
        type: t.SAVE_SHELLSETTINGS,
        payload: currentSettings
    }
}
export function saveHeightParam(contentheigth) {
    return {
        type: t.SAVE_HEIGHTPARAM,
        payload: contentheigth
    }
}
export function saveWidthParam(contentwidth) {
    return {
        type: t.SAVE_WIDTHPARAM,
        payload: contentwidth
    }
}
export function setDebugLabels() {
    return {
        type: t.SET_DEBUG_LABELS
    }
}
export function loadLabels() {
    let appobj = loadFromLocalStorage(constants.APPSETTINGS, initialState.appsettings);
    //console.log('loadLabels lang:', lang);
    const lang = appobj.lang;
    return function (dispatch) {
        let config = {
            headers: {
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': '0',
            }
        }

        axios.get(`/${lang}.json`, config)
            .then((response) => {
                dispatch(
                    {
                        type: t.LOAD_LABELS,
                        payload: {
                            labels: response.data
                        }
                    });
            })
            .catch((err) => {
                axios.get('/1043.json', config)
                    .then((response) => {
                        dispatch(
                            {
                                type: t.LOAD_LABELS,
                                payload: {
                                    labels: response.data
                                }
                            });
                    })
            })
    }
}
export function saveGridFilters(gridname, gridstate) {
    return {
        type: t.SAVE_GRID_FILTERS,
        payload: {gridname, gridstate}
    }
}
